import type { ActivityModule } from '../../core/activity';
import { mountNumberSequence } from './ui';
import levelsData from './levels.json';
import './style.css';

export const numberSequence: ActivityModule = {
  id: 'number_sequence',
  title: 'Ligue os pontos',
  description: 'Clique nos pontos em ordem (1, 2, 3...) pra desenhar a figura.',
  ageMin: 4,
  ageMax: 8,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/number_sequence/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountNumberSequence,
};
